import { writable } from 'svelte/store';
export const isAlticeStore = writable(false);
